import { AccountGroupProfileWithAumIncluded } from 'views/portfolio/account-aum-queries';

import { CompactPortfolioList } from './CompactPortfolioList';

interface PortfolioListProps {
    accountGroupProfiles: AccountGroupProfileWithAumIncluded[];
}

export const PortfolioList = ({ accountGroupProfiles }: PortfolioListProps) => (
    <CompactPortfolioList accountGroupProfiles={accountGroupProfiles} />
);
